import { RSAA } from "redux-api-middleware";
import * as actionTypes from "./actionTypes";

/**
 * PUT /users/me/settings
 * - request snackbar
 * - success snackbar
 * @returns {*}
 */
export const updateSettings = (settings, uuid = null) => {
    //need to save data by console-api if no uuid!
    let endpoint =
        uuid === null
            ? "/users/me/settings"
            : process.env.NX_USER_MANAGEMENT_API_URL + `/v1/users/${uuid}/settings`;

    return {
        [RSAA]: {
            endpoint: endpoint,
            method: "PUT",
            body: JSON.stringify(settings),
            types: [
                {
                    type: actionTypes.UPDATE_SETTINGS_REQUEST,
                    meta: { snackbar: { message: "modules.preferences.snackbar.request" } },
                },
                {
                    type: actionTypes.UPDATE_SETTINGS_SUCCESS,
                    meta: { snackbar: { message: "modules.preferences.snackbar.success" } },
                },
                {
                    type: actionTypes.UPDATE_SETTINGS_FAILURE,
                    meta: { snackbar: { message: "modules.preferences.snackbar.failure" } },
                },
            ],
        },
    };
};
